
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ProjectService } from 'src/app/shared/services/project.service';

@Component({
  imports: [RouterOutlet],
  templateUrl: './projects-page.component.html',
  styleUrl: './projects-page.component.scss'
})
export class ProjectsPageComponent {


  constructor(
    public projectService: ProjectService
  ) { }
}
